import { AppStore } from "@/store";
import { logger } from "@/modules/logger";
import { DateTime } from "luxon";

export const getSendSuggestions = ({
  store,
  isOnboarding = checkIfIsOnboarding({ store }),
  useHuddleSuggestions = false,
}: {
  store: AppStore;
  isOnboarding?: boolean;
  useHuddleSuggestions?: boolean;
}): { title: string; subtitle?: string; message: string }[] => {
  if (isOnboarding) {
    return [
      {
        title: "Get me started with Mem",
        subtitle: "Mem will help you create notes and collections based on your priorities",
        message:
          "Help me get started by creating some notes. Ask me about my projects, top of mind, and what I want to use Mem for. Create collections for my projects to keep me organized.",
      },
      {
        title: "Get to work on a specific topic",
        subtitle: "Collaborate with Mem to create notes about something top of mind",
        message:
          "Help me build a deep dive on a topic. Ask me for the topic and then make a new note with details and I’ll help edit with suggestions.",
      },
    ];
  }

  if (useHuddleSuggestions) {
    return [
      {
        title: "What should I do today?",
        message: "What should I do today?",
      },
      {
        title: "Give me an overview of my last 14 days",
        message: "Give me an overview of my last 14 days",
      },
    ];
  }

  return [
    {
      title: "What should I follow up on from this week?",
      message: "What should I follow up on from this week?",
    },
    {
      title: "Give me an overview of my last 14 days",
      message: "Give me an overview of my last 14 days",
    },
  ];
};

export const checkIfIsOnboarding = ({ store }: { store: AppStore }) => {
  // Debug override takes precedence
  if (store.debug.forceOnboardingMode) {
    return true;
  }

  const myAccount = store.account.myAccount;

  if (!myAccount?.createdAt) {
    logger.warn({
      message: "checkIfIsOnboarding: myAccount or createdAt is missing",
      info: {
        hasMyAccount: !!myAccount,
        createdAt: myAccount?.createdAt ?? null,
      },
    });
    return false;
  }

  const now = DateTime.now();
  const createdAt = DateTime.fromISO(myAccount.createdAt);
  const sevenDaysAgo = now.minus({ days: 7 });

  if (createdAt <= sevenDaysAgo) {
    return false;
  }

  return true;
};
